import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { api } from "../../_services";
import { isValidStartDate, isValidEndDate } from "../../_helpers";
import { Redirect } from "react-router";
import MenuBar from "../MenuBar";
import FilterMenuBar from "../FilterMenuBar";
import FontAwesome from "react-fontawesome";
import DateTimePicker from "../DateTimePicker";
import PrecinctDropdown from "../PrecinctDropdown";
import SensorTypeDropdown from "../SensorTypeDropdown";
import DeviceDropdown from "../DeviceDropdown";
import AlertTypeDropdown from "../AlertTypeDropdown";
import ResolutionCategoryDropdown from "../ResolutionCategoryDropdown";
import ChartTimeDropdown from "../ChartTimeDropdown";
import Switch from "react-switch";
import _ from "lodash";
import { pageReports } from "../../_actions";
import { Row, Col, form, Button, HelpBlock } from "react-bootstrap";
import "./index.css";

class CustomReportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      validated: false,
      resetFilter: false,
      alertNoteCheck: false,
      dataChartCheck: false,
      params: {
        include_alert_type_and_note_resolution_details: false,
        include_telemetry_charts: false,
        note_resolution_categories: [],
        precincts: [],
        alert_types: [],
        devices: [],
        disciplines: []
      }
    };
  }

  componentDidMount() {
    this.setState(() => {
      return {
        loading: true
      };
    });
    this.props.pageReports();
  }

  resetFilter = () => {
    this.setState(() => {
      return {
        resetFilter: true,
        params: {}
      };
    });
  };

  setStartDate = e => {
    const params = this.state.params;
    params.start_date = e._d ? e._d.toISOString() : "";
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setEndDate = e => {
    const params = this.state.params;
    params.end_date = e._d ? e._d.toISOString() : "";
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setPrecinct = val => {
    const params = this.state.params;
    params.precincts = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setDiscipline = val => {
    const params = this.state.params;
    params.disciplines = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setDevice = val => {
    const params = this.state.params;
    params.devices = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setAlerType = val => {
    const params = this.state.params;
    params.alert_types = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setNoteResolutionType = val => {
    const params = this.state.params;
    params.note_resolution_categories = _.map(val, item => {
      return item.id;
    });
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setTimePerChart = val => {
    const params = this.state.params;
    params.sensor_data_chart_size = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  handleAlertNoteToggleChange = checked => {
    const params = this.state.params;
    params.include_alert_type_and_note_resolution_details = checked;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false,
        alertNoteCheck: checked
      };
    });
  };

  handleSensorDataChartsToggleChange = checked => {
    const params = this.state.params;
    params.include_telemetry_charts = checked;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false,
        dataChartCheck: checked
      };
    });
  };

  generateReport = () => {
    const params = this.state.params;
    this.setState(() => {
      return { validated: true };
    });
    if (params.start_date && params.start_date && !moment(params.end_date).isBefore(params.start_date)) {
      params.end_date = moment(params.end_date)
        .add(1, "d")
        .subtract(1, "s")
        .toISOString();
      const url = "/api/v1/compliance_summary_reports/";
      const errorMsg = "Unable to generate reports.";

      api.postFetch(url, params, this.props.user.token, errorMsg, true).then(json => {
        if (json) {
          this.setState({ redirect: "/reports/" });
        }
      });
    }
  };

  cancelReportGeneration = () => {
    this.setState({ redirect: "/reports/" });
  };

  renderMainTitle = () => {
    return (
      <div className="mainTitle">
        <h1>Create Compliance Summary Report</h1>
      </div>
    );
  };

  isValidStartDate = current => isValidStartDate(current, this.state.params.end_date);

  isValidEndDate = current => isValidEndDate(current, this.state.params.start_date);

  renderDateTimePickerRow = () => {
    const { params, resetFilter, validated } = this.state;
    return (
      <Row>
        <Col md={6}>
          <DateTimePicker
            timePeriod="From"
            changeDate={this.setStartDate}
            reset={resetFilter}
            defaultValue={params.start_date}
            disableTime={true}
            isValidDate={this.isValidStartDate}
          />
          {validated && !params.start_date ? (
            <div className="errorMsgCon">
              <HelpBlock>
                <FontAwesome name="exclamation-circle" /> Please select start date.
              </HelpBlock>
            </div>
          ) : null}
          {validated && params.start_date && params.end_date && moment(params.end_date).isBefore(params.start_date) ? (
            <div className="errorMsgCon">
              <HelpBlock>
                <FontAwesome name="exclamation-circle" /> Incorrect date period.
              </HelpBlock>
            </div>
          ) : null}
        </Col>
        <Col md={6}>
          <DateTimePicker
            timePeriod="To"
            changeDate={this.setEndDate}
            reset={resetFilter}
            defaultValue={params.end_date}
            disableTime={true}
            isValidDate={this.isValidEndDate}
          />
          {validated && !params.end_date ? (
            <div className="errorMsgCon">
              <HelpBlock>
                <FontAwesome name="exclamation-circle" /> Please select end date.
              </HelpBlock>
            </div>
          ) : null}
        </Col>
      </Row>
    );
  };

  renderPrecinctPickerRow = () => {
    return (
      <PrecinctDropdown
        change={this.setPrecinct}
        reset={this.state.resetFilter}
        defaultValue={this.state.params.precincts}
      />
    );
  };

  renderDisciplinePickerRow = () => {
    return (
      <SensorTypeDropdown
        change={this.setDiscipline}
        reset={this.state.resetFilter}
        defaultValue={this.state.params.disciplines}
      />
    );
  };

  setLoadingState = val => {
    this.setState({ loading: val });
  };

  renderDevicePickerRow = () => {
    return (
      <DeviceDropdown
        loading={this.setLoadingState}
        change={this.setDevice}
        precinct={this.state.params.precincts}
        discipline={this.state.params.disciplines}
        reset={this.state.resetFilter}
        defaultValue={this.state.params.devices}
      />
    );
  };

  renderAlertTypePickerRow = () => {
    const { alertNoteCheck } = this.state;
    if (!alertNoteCheck) {
      return null;
    }

    return (
      <AlertTypeDropdown
        change={this.setAlerType}
        reset={this.state.resetFilter}
        defaultValue={this.state.params.alertTypes}
      />
    );
  };

  renderNoteResolutionTypePickerRow = () => {
    const { alertNoteCheck } = this.state;
    if (!alertNoteCheck) {
      return null;
    }

    return (
      <ResolutionCategoryDropdown
        change={this.setNoteResolutionType}
        reset={this.state.resetFilter}
        defaultValue={this.state.params.noteResolutionTypes}
        pageType={"createReport"}
      />
    );
  };

  renderTimePerChartPickerRow = () => {
    const { dataChartCheck } = this.state;
    if (!dataChartCheck) {
      return null;
    }

    return (
      <ChartTimeDropdown
        change={this.setTimePerChart}
        reset={this.state.resetFilter}
        defaultValue={this.state.params.sensor_data_chart_size}
      />
    );
  };

  renderAlertNoteToggleRow = () => {
    return (
      <div className="toggleRow">
        <label htmlFor="normal-switch">
          <span>Show alert type and note resolution details</span>
          <Switch
            onChange={this.handleAlertNoteToggleChange}
            checked={this.state.alertNoteCheck}
            onColor="#00bad4"
            height={31}
            className="react-switch"
            id="react-switch1"
          />
        </label>
      </div>
    );
  };

  renderSensorDataChartToggleRow = () => {
    return (
      <div className="toggleRow">
        <label htmlFor="normal-switch">
          <span>Include sensor data charts</span>
          <Switch
            onChange={this.handleSensorDataChartsToggleChange}
            checked={this.state.dataChartCheck}
            onColor="#00bad4"
            height={31}
            className="react-switch"
            id="react-switch1"
          />
        </label>
      </div>
    );
  };

  renderButtonRow = () => {
    return (
      <div className="buttonContainer buttonRow">
        <Button className="btn-cancel" bsStyle="default" onClick={this.cancelReportGeneration}>
          Cancel
        </Button>
        <Button className="btn-filter" bsStyle="primary" onClick={this.generateReport}>
          Create Report
        </Button>
      </div>
    );
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  renderMainContent = () => {
    return (
      <div className="mainContent">
        <Row>
          <Col md={6}>
            <div className="panel-div createReportPanel">
              <form>
                {this.renderDateTimePickerRow()}
                {this.renderPrecinctPickerRow()}
                {this.renderDisciplinePickerRow()}
                {this.renderDevicePickerRow()}
                {this.renderAlertNoteToggleRow()}
                {this.renderAlertTypePickerRow()}
                {this.renderNoteResolutionTypePickerRow()}
                {this.renderSensorDataChartToggleRow()}
                {this.renderTimePerChartPickerRow()}
                {this.renderButtonRow()}
              </form>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    if (this.state.redirect) {
      return <Redirect push to={this.state.redirect} />;
    }

    if (this.state.loading === false) {
      return (
        <div>
          <MenuBar />
          <FilterMenuBar />
          <div className="mainPanelCon">
            <div className="container">
              {this.renderMainTitle()}
              {this.renderMainContent()}
            </div>
          </div>
        </div>
      );
    } else {
      return <div>{this.renderLoadingPage()}</div>;
    }
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(
  mapStateToProps,
  { pageReports }
)(CustomReportPage);



// WEBPACK FOOTER //
// ./src/_components/CustomReportPage/index.js